import LazyImages from './LazyImages';
import { getAlternateTemplate } from '../services/template.service';
import { getElementOrParentByClassName } from '../helpers/utils';
let hoverExitTimeout = null;
const exitTimeoutMs = 150;
export default (($) => {
    console.log('UNTUCKit : Module : Meganav : loaded');
    async function lazyLoadMeganav(slug = null) {
        console.log("UNTUCKit : Module : Meganav : lazyLoadMeganav");
        await loadMeganav(false, slug, null);
    }
    async function init() {
        // console.log('UNTUCKit : Module : Meganav : init');
        // const urlParams = new URLSearchParams(window.location.search);
        // if (urlParams.has('slug') && urlParams.has('navpreview')) {
        //   const slug = urlParams.get('slug');
        //   const draft = urlParams.get('draft');
        //   await loadMeganav(true, slug, draft);
        // }
        // else if (!window.UNTUCKitConfig.header.navigationHideDesktopMenu)
        //   await loadMeganav();
        // else {
        //   console.log('UNTUCKit : Module : Meganav : wait to load');
        //   setTimeout(async () => {
        //     if ($('.header__desktop-menu-list').is(':empty')){
        //       console.log('UNTUCKit : Module : Meganav : failed to load.');
        //       await loadMeganav();
        //     } else {
        //       console.log('UNTUCKit : Module : Meganav : loaded elsewhere.');
        //     }
        //   }, 3000);
        // }
    }
    // @ts-expect-error: exposed globally for use in DY
    window.Meganav = {
        lazyLoadMeganav
    };
    async function loadMeganav(isPreview = false, slug = null, draft = null) {
        console.log("UNTUCKit : Module : Meganav : lazy loading Meganav");
        const urlParams = {};
        if (isPreview) {
            urlParams.preview = 1;
        }
        if (slug) {
            urlParams.slug = slug;
        }
        if (draft) {
            urlParams.draft = draft;
        }
        try {
            const data = await getAlternateTemplate('', 'menu', urlParams);
            $('.header__desktop-menu-list').html(data);
            const numLinks = $('.header__desktop-menu-list').children("li").length;
            $('.header__desktop-menu-list').addClass(`header__desktop-menu-list--${numLinks}`);
            LazyImages.update();
        }
        catch (e) {
            console.error(e.message || e);
        }
    }
    return {
        init
    };
})($);
const header = document.querySelector('.js-header');
if (header) {
    header.addEventListener('mouseover', onEnter);
    header.addEventListener('focusin', onEnter);
    header.addEventListener('mouseout', onLeave);
    header.addEventListener('focusout', onLeave);
    header.addEventListener('click', onClick);
}
function onEnter(e) {
    const target = e.target;
    const dropdownEl = getElementOrParentByClassName(target, 'js-dropdown');
    if (dropdownEl) {
        clearTimeout(hoverExitTimeout);
        document.querySelectorAll('.js-dropdown').forEach(el => el.classList.remove('is-active'));
        dropdownEl.classList.add('is-active');
    }
}
function onLeave(e) {
    const target = e.target;
    const dropdownEl = getElementOrParentByClassName(target, 'js-dropdown');
    if (dropdownEl) {
        hoverExitTimeout = window.setTimeout(() => {
            dropdownEl.classList.remove('is-active');
        }, exitTimeoutMs);
    }
}
function onClick(e) {
    const target = e.target;
    if (target.matches('.menu-link, .js-menu-link, .col-block-link a, .col-block-title a, .col-image-link a, .m-menu-section-label, .m-menu-group-label, .m-menu-group-link, .m-menu-section-link')) {
        const clicked = buildClicked($(target));
        const navPosition = 'top';
        window.dataLayer.push({
            event: 'Nav Click',
            itemClicked: clicked,
            navPosition: navPosition,
        });
    }
}
function buildClicked($el, clicked) {
    if ($el.data('dlv-item-clicked')) {
        return $el.data('dlv-item-clicked');
    }
    const $parent = $el
        .parent()
        .parents('.menu-link-outer:eq(0)')
        .find('> a');
    const text = $el.has("span").length ? $el.find('span').text() : $el.text();
    clicked = typeof clicked === 'undefined' ? text : clicked;
    if ($parent.length) {
        const newText = $parent.find('span').text();
        clicked = buildClicked($parent, newText + ' > ' + clicked);
    }
    return clicked;
}
